import { ProxyTypeSet } from 'immer/dist/internal';
import styled from 'styled-components';
import { GlobalModal, showGlobalModal } from '../../services/modal';
import Button, { ButtonColor, ButtonSize, ButtonWidth } from '../../ui/Button';
import Icon from '../../ui/Icon';
import Separator, { SeparatorColor, SeparatorOrientation } from '../../ui/Separator';
import Tooltip from '../../ui/Tooltip/Tooltip';
import { colorOpacity, colorShade } from '../../utils/style';

interface Props {

}

export default function Menu({ }: Props) {
    return (
        <Wrapper className="menu-container">
            <Tooltip title='Add Task' offset={{ x: 0, y: 10 }}>
                <Button size={ButtonSize.MEDIUM} color={ButtonColor.TRANSPARENT} onClick={() => showGlobalModal(GlobalModal.ADD_TASK)} className="menu-add-button menu-add-quest" ><Icon className="menu-add-quest-icon" icon="quest" size={40} /></Button>
            </Tooltip>
            <Separator color={SeparatorColor.SHADE} orientation={SeparatorOrientation.VERTICAL}></Separator>
            <Tooltip title='Stats' offset={{ x: 0, y: 10 }}>
                <Button size={ButtonSize.MEDIUM} color={ButtonColor.TRANSPARENT} onClick={() => showGlobalModal(GlobalModal.STATS)} className='menu-stats' rightOrnament={<Icon className="menu-stats-icon" icon="stats7" size={40} />}></Button>
            </Tooltip>
            <Tooltip title='Settings' offset={{ x: 0, y: 10 }}>
                <Button size={ButtonSize.MEDIUM} color={ButtonColor.TRANSPARENT} onClick={() => showGlobalModal(GlobalModal.SETTINGS)} className='menu-settings' rightOrnament={<Icon className="menu-settings-icon" icon="settings3" size={40} />}></Button>
            </Tooltip>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;

    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 10px;

    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);

    background-color: ${props => props.theme.backgroundColor};
    background-color: #00000022;
    background-color: ${props => colorOpacity(colorShade(props.theme.backgroundColor, 0.1), 1)};
    border-radius: 30px;

    .menu-add-button { padding: 0 24px}

    .menu-add-quest:hover .menu-add-quest-icon { transform: translateY(-5px); }
    .menu-stats:hover .menu-stats-icon { transform: translateY(-5px); }
    .menu-settings:hover .menu-settings-icon { transform: rotate(90deg); }

    .menu-add-quest-icon { transition: transform var(--ui-animation-duration); }
    .menu-stats-icon { transition: transform var(--ui-animation-duration); }
    .menu-settings-icon { transition: transform 0.3s; }

`